import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	anonymous: {
		id: 'issue-field-reporter-inline-edit-full.reporter.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text to display when no reporter has been specified.',
	},
});
